import { useEffect, useState } from "react";

// Solo esquinas: visible como medida de seguridad, sin tapar el centro de la clase
const POSITIONS = [
  { top: "6%", right: "5%" },
  { bottom: "18%", right: "5%" },
  { bottom: "18%", left: "5%" },
  { top: "6%", left: "5%" },
];

const VISIBLE_MS = 15000;
const HIDDEN_MS = 30000; // visible 15s de cada 45s

export const VideoWatermark = ({ label }) => {
  const [index, setIndex] = useState(0);
  const [visible, setVisible] = useState(true);

  useEffect(() => {
    let timer;
    const cycle = (show) => {
      setVisible(show);
      if (!show) setIndex((i) => (i + 1) % POSITIONS.length);
      timer = setTimeout(() => cycle(!show), show ? VISIBLE_MS : HIDDEN_MS);
    };
    timer = setTimeout(() => cycle(false), VISIBLE_MS);
    return () => clearTimeout(timer);
  }, []);

  if (!label) return null;

  return (
    <div
      className="absolute inset-0 pointer-events-none select-none z-20 overflow-hidden"
      data-testid="video-watermark"
    >
      <span
        className="absolute text-xs sm:text-sm font-medium tracking-wide whitespace-nowrap rounded px-2 py-1 transition-opacity duration-1000"
        style={{
          ...POSITIONS[index],
          color: "rgba(255,255,255,0.62)",
          background: "rgba(0,0,0,0.28)",
          textShadow: "0 1px 4px rgba(0,0,0,0.9)",
          opacity: visible ? 1 : 0,
        }}
      >
        {label}
      </span>
    </div>
  );
};

export default VideoWatermark;
